<template>
  <v-ons-page class="l-content l-card">
    <div class="container">
      <div class="card-wrapper">
        <img :src="card_image">
      </div>

      <v-ons-button v-for="category in categories" :key="category.pac_id" modifier="large" @click="view(category)">
        <i :class="category.pac_icon"></i>{{ categoryName(category) }}<i class="absoluteIcon" :class="category.pac_icon"></i>
      </v-ons-button>
    </div>
  </v-ons-page>
</template>

<script>
  import PartnerCategory from './PartnerCategory.vue';

  export default {
    data () {
      return {
        categories: [],
        card_image: card_image
      };
    },
    methods: {
      view(category) {
        self = this;
        this.$store.commit('navigator/push', {
          extends: PartnerCategory,
          data() {
            return {
              category: category,
              title: self.categoryName(category)
            };
          }
        });
      },
      categoryName(category) {
        switch(this.$i18n.locale) {
          case 'nl':
            return category.pac_nameNL;
          default:
            return category.pac_nameFR;
        }
      }
    },
    created() {
      axios
        .get('/partners/categories/list', {
          params: {
            'x-secundo-auth': 'ABC123',
          }
        })
        .then(response => {
          this.categories = response.data;
        });
    }
  };
</script>


// WEBPACK FOOTER //
// Card.vue?a832cc8e